// extracted by mini-css-extract-plugin
export default {"back-link":"BackLink_back-link__0IXvH","back-link__icon":"BackLink_back-link__icon__hQsfd","back-link__text":"BackLink_back-link__text__CjfVv"};